'use client'

import styles from './UiPageHead.module.css'

/*
 * 頁面標題那一塊 —— 舊站 dg-app.css 的 .dg-header-section:
 *
 *   <div class="dg-header-section">
 *     <h1 class="dg-title">24H 線上客服 <span class="dg-title-en">SERVICE</span></h1>
 *     <div class="dg-title-line"></div>
 *   </div>
 *
 * 客服、註冊、忘記密碼、身分驗證…好幾頁都是同一塊，所以抽成元件
 *（CONVENTIONS:兩頁以上長得一樣才抽）。`lead` 是標題底下那一句說明（.dg-lead）。
 */
export default function UiPageHead({ title, en = '', lead = '' }) {
  return (
    <>
      <div className={styles.head}>
        <h1 className={styles.title}>
          {title}
          {en ? <span className={styles.en}>{en}</span> : null}
        </h1>
        <div className={styles.line} />
      </div>

      {lead ? <p className={styles.lead}>{lead}</p> : null}
    </>
  )
}
